"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Style = require("../core/Style");

var _sizes = require("HubStyleTokens/sizes");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  &&& > * {\n    ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-left: ", ";\n  margin-top: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: ", ";\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ", ";\n  margin-left: -", ";\n  margin-top: -", ";\n\n  /* this makes the responsive scenario work */\n  @media only screen and (max-width: ", ") {\n    flex-grow: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ALIGN_OPTIONS = {
  baseline: 'baseline',
  center: 'center',
  start: 'flex-start',
  end: 'flex-end',
  stretch: 'stretch'
};
var JUSTIFY_OPTIONS = {
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start'
};
var flexWrapperMixin = (0, _styledComponents.css)(_templateObject(), function (props) {
  return ALIGN_OPTIONS[props.alignItems];
}, function (props) {
  return JUSTIFY_OPTIONS[props.justify];
}, function (props) {
  return (0, _Style.remCalc)(props.horizontalGap);
}, function (props) {
  return (0, _Style.remCalc)(props.verticalGap);
}, (0, _Style.remCalc)(_sizes.GRID_BREAKPOINT_SMALL, 'em'));
var flexWrapperChildMixin = (0, _styledComponents.css)(_templateObject2(), function (props) {
  return (0, _Style.remCalc)(props.horizontalGap);
}, function (props) {
  return (0, _Style.remCalc)(props.verticalGap);
});

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "UIButtonWrapper__Wrapper",
  componentId: "sc-120391d-0"
})(_templateObject3(), function (props) {
  return props.layout === 'default' && flexWrapperMixin;
}, function (props) {
  return props.layout === 'default' && flexWrapperChildMixin;
});

var UIButtonWrapper = function UIButtonWrapper(props) {
  var alignItems = props.alignItems,
      children = props.children,
      horizontalGap = props.horizontalGap,
      justify = props.justify,
      layout = props.layout,
      __nested = props.nested,
      verticalGap = props.verticalGap,
      rest = (0, _objectWithoutProperties2.default)(props, ["alignItems", "children", "horizontalGap", "justify", "layout", "nested", "verticalGap"]);
  return _react.default.createElement("div", rest, _react.default.createElement(Wrapper, {
    alignItems: alignItems,
    horizontalGap: horizontalGap,
    justify: justify,
    layout: layout,
    verticalGap: verticalGap
  }, children));
};

UIButtonWrapper.propTypes = {
  alignItems: _react.PropTypes.oneOf(Object.keys(ALIGN_OPTIONS)),
  children: _react.PropTypes.node,
  justify: _react.PropTypes.oneOf(Object.keys(JUSTIFY_OPTIONS)),
  horizontalGap: _react.PropTypes.number,
  layout: _react.PropTypes.oneOf(['default', 'legacy']),
  nested: _react.PropTypes.bool,
  verticalGap: _react.PropTypes.number
};
UIButtonWrapper.defaultProps = {
  alignItems: 'center',
  horizontalGap: parseInt(_sizes.BASE_SPACING_X, 10),
  layout: 'default',
  verticalGap: parseInt(_sizes.BASE_SPACING_Y, 10)
};
UIButtonWrapper.displayName = 'UIButtonWrapper';
var _default = UIButtonWrapper;
exports.default = _default;
module.exports = exports.default;